<div class="tw-m-auto print:tw-w-auto  lg:tw-w-[1100px]  tw-w-auto">
	<app-component-loader
	[loading]="LoaderService.loadingGrowthChart"
></app-component-loader>

<div class="tw-flex justify-content-end tw-border-1 tw-border-gray-300 tw-border-b ">
	<div class="tw-flex tw-flex-col tw-items-start tw-justify-center tw-mr-auto tw-ml-2">
		<span class="tw-text-xl print:tw-text-base  tw-font-bold">Growth in Reading Achievement</span>
		<span class="tw-text-sm tw-font-bold">{{this?.selectedPhase?.title }}</span>
		<span class="tw-text-base tw-text-gray-600">in {{data?.testScale?.[1011].unitName || "loading" }}</span>
		<div class="tw-flex tw-items-center tw-gap-2 tw-mt-1">
			<span class="tw-text-xs tw-text-gray-500 tw-min-w-[130px]">Generated on: {{getLastPulledFormatted()}}</span>

				<i class=" print:tw-hidden fa tw-text-sm fa-refresh tw-mr-1 tw-cursor-pointer tw-text-blue-600 hover:tw-text-blue-800" aria-hidden="true" (click)="clearCacheAndReload()"></i>

		</div>
	</div>
	<div class="tw-flex tw-overflow-x-auto tw-w-8/12 balloon-phases-box">
		<div *ngFor="let data of topData" class="tw-border-l-2 tw-border-t-2  tw-border-gray-200 sm:tw-flex tw-hidden tw-w-full sm:tw-w-56 print:mb-0 print:tw-w-38 tw-bg-gray-100 tw-p-1.5 tw-cursor-pointer hover:tw-bg-gray-200 print:tw-bg-transparent" (click)="setPhase(data.id)" [ngClass]="{'!tw-bg-white tw-outline-2 tw-outline-offset-2 tw-outline-white print:!tw-bg-white': selectedPhase?.assessmentBookId == data.id}"
		[attr.data-phase-title]="data.title"
		[attr.data-phase-id]="data.id">
			<div class="tw-flex tw-items-center tw-justify-center tw-self-center pr-1">
				<img src="{{data.image}}" class="tw-max-w-[30px] print:tw-max-w-[20px] " />
			</div>
			<div class="tw-flex tw-flex-col tw-w-full ">
				<h3 class="tw-text-lg   sm:tw-text-base tw-font-bold tw-text-gray-800">{{data.title}}</h3>
				<p class="tw-text-xs tw-text-gray-500">&nbsp;</p>
				<div class="tw-flex tw-justify-between tw-w-full tw-text-gray-800 tw-font-semibold">
					<div class="tw-flex tw-flex-col tw-items-left" data-value-type="baseline">
						<span class="tw-text-xl  sm:tw-text-base" data-phase-value="baseline" [attr.data-phase-value-num]="data.baseline" [@valueChange]="animateKey">{{data.baseline}}<span *ngIf="!showRaw" class="tw-text-xs tw-p-1 tw-inline-block tw-transition-opacity tw-duration-300 tw-ease-in-out">%</span></span>
						<span class="tw-text-[10px] tw-text-gray-500 print:tw-text-gray-800">BASELINE</span>
					</div>
					<div class="tw-flex tw-flex-col tw-items-left" data-value-type="current">
						<span class="tw-text-xl  sm:tw-text-base" data-phase-value="current" [attr.data-phase-value-num]="data.current" [@valueChange]="animateKey">{{data.current}}<span *ngIf="!showRaw" class="tw-text-xs tw-p-1 tw-inline-block tw-transition-opacity tw-duration-300 tw-ease-in-out">%</span></span>
						<span class="tw-text-[10px] tw-text-gray-500 print:tw-text-gray-800">CURRENT</span>
					</div>
				</div>
			</div>
		</div>

		<div class="tw-border-l-2 tw-border-gray-200 tw-border-t-2 tw-border-r-2 tw-pr-1 tw-pl-1 tw-flex tw-w-full sm:tw-w-56 print: mt-0 print:tw-w-38 tw-bg-gray-100 print:tw-bg-transparent" data-phase-title="Complete" data-phase-id="complete">
			<div class="tw-flex tw-justify-center tw-self-center pr-1">
				<img src="/assets/img/balloon_star.png" class="tw-max-w-[30px] print:tw-max-w-[20px]" />
			</div>
			<div class="tw-flex  tw-flex-col tw-w-full">
				<h3 class="tw-text-lg  sm:tw-text-base tw-font-bold tw-text-gray-800">Complete</h3>
				<p class="tw-text-xs tw-text-gray-500 print:tw-text-gray-800">Phase I, II and III</p>
				<div class="tw-flex tw-justify-between tw-w-full tw-text-gray-800 tw-font-semibold">
					<div class="tw-flex tw-flex-col tw-items-left" data-value-type="baseline">
						<span class="tw-text-xl  sm:tw-text-base tw-mt-1.5" data-phase-value="baseline" [@valueChange]="animateKey">{{ showRaw ? this.completed.baseline.raw : this.completed.baseline.percentage || 0}}<span *ngIf="!showRaw" class="tw-text-xs tw-p-1 tw-inline-block tw-transition-opacity tw-duration-300 tw-ease-in-out">%</span></span>
						<span class="tw-text-[10px] tw-text-gray-500 print:tw-text-gray-800">BASELINE</span>
					</div>
					<div class="tw-flex tw-flex-col tw-items-left" data-value-type="current">
						<span class="tw-text-xl  sm:tw-text-base tw-mt-1.5" data-phase-value="current" [@valueChange]="animateKey">{{ showRaw ? this.completed.current.raw : this.completed.current.percentage || 0}}<span *ngIf="!showRaw" class="tw-text-xs tw-p-1 tw-inline-block tw-transition-opacity tw-duration-300 tw-ease-in-out">%</span></span>
						<span class="tw-text-[10px] tw-text-gray-500 print:tw-text-gray-800">CURRENT</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div  class="reverse-scroll tw-overflow-y-scroll tw-h-[580px] print:tw-h-full print:tw-overflow-auto" style="display: block">
<div *ngFor="let phase of phases; let i = index" [id]="'phase-' + phase.id" class="tw-mb-14 print:mb-0 balloon-phase-body" >
	<div class="tw-grid  tw-grid-rows-5  tw-border-2 tw-border-b-0  tw-border-gray-300 tw-w-full print:tw-h-max">
		<ng-template ngFor let-division let-j="index" [ngForOf]="phase.divisions">
			<div class="tw-row-start-{{5-j}} tw-col-span-{{j === phase.divisions.length - 1 ? 7 : 3+j}} tw-border-b-2 tw-border-gray-300">
				<div class="tw-flex tw-flex-row tw-items-start tw-justify-start tw-h-full">
					<div class="tw-min-w-8 tw-h-full {{division?.color}} tw-border-r-2 tw-border-gray-300"></div>
					<div class="tw-flex tw-flex-col tw-items-start tw-justify-start tw-text-sm lg:tw-text-[13px] tw-line-clamp-2 tw-h-full tw-p-1.5">
						<span class="tw-text-xl tw-font-thin">{{division.title}}</span>
						<div class="tw-max-w-[500px]"><span class="tw-text-sm lg:tw-text-[13px] sm:tw-line-clamp-none tw-line-clamp-2 ">{{division.description}}</span></div>
					</div>
				</div>
			</div>
			<div class="tw-col-start-{{8-j}} tw-col-span-{{3+j}} tw-border-b-2 tw-border-gray-300 tw-w-full" [attr.data-division-name]="division.title" [attr.data-phase-id]="phase.id">
				<div class="tw-flex tw-items-center tw-text-base  md:tw-text-4xl tw-font-sans">
					<div class="tw-p-1 md:tw-min-w-36 tw-text-end tw-relative tw-overflow-hidden" data-value-type="baseline" [attr.data-division-value]="getDivisionDisplayValue(phase.id, 'baseline', j)">
						<span class="tw-inline-block" [@valueChange]="animateKey">{{getDivisionDisplayValue(phase.id, 'baseline', j)}}</span>
						<span *ngIf="!showRaw" class="tw-text-xl tw-p-1 tw-inline-block tw-transition-opacity tw-duration-300 tw-ease-in-out">%</span>
					</div>
					<img src="assets/img/balloon_{{phase.id}}.png" class="sm:tw-w-[60px] tw-w-[30px] print:tw-w-12 tw-y-2 tw-mt-2"/>
					<div  class="tw-p-1 md:tw-min-w-36 tw-relative tw-overflow-hidden" data-value-type="current" [attr.data-division-value]="getDivisionDisplayValue(phase.id, 'current', j)">
						<span class="tw-inline-block" [@valueChange]="animateKey">{{getDivisionDisplayValue(phase.id, 'current', j)}}</span>
						<span *ngIf="!showRaw" class="tw-text-xl tw-p-1 tw-inline-block tw-transition-opacity tw-duration-300 tw-ease-in-out">%</span>
					</div>
				</div>

			</div>
		</ng-template>

</div>

<div class="tw-grid tw-grid-cols-12  tw-grid-rows-1 tw-gap-0  sm:tw-text-xl tw-text-lg tw-my-2  tw-w-full ">
	<div class="tw-col-span-3 tw-ml-8 tw-row-start-1 tw-items-center tw-justify-start tw-h-full tw-mt-1  tw-relative tw-col-start-1">
		<span class="tw-text-sm tw-text-gray-500"> # of students not assessed: <span class="tw-font-bold">{{getNotAssessedCount('current')}}</span></span>
	</div>
	<div class="tw-col-span-2 tw-row-start-1 tw-items-center tw-justify-end tw-h-full  print:tw-hidden tw-relative tw-col-start-12" (click)="toggleDataDisplay()">
		<div class="tw-relative tw-w-20 tw-h-8 tw-bg-white tw-border tw-border-gray-300  tw-p-1 tw-transition-all tw-duration-300 tw-ease-in-out tw-cursor-pointer">
			<div class="tw-absolute tw-top-1 tw-left-1 tw-w-9 tw-h-6 tw-bg-[#243670]  tw-transition-all tw-duration-300 tw-ease-in-out" [class.tw-translate-x-9]="showRaw"></div>
			<div class="tw-relative tw-z-10 tw-w-9 tw-h-6 tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-medium tw-transition-all tw-duration-300" [class.tw-text-white]="!showRaw" [class.tw-text-gray-700]="showRaw">
				<i class="fa fa-percent" aria-hidden="true"></i>
			</div>
			<div class="tw-absolute tw-top-1 tw-z-10 tw-w-9 tw-h-6 tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-bold tw-transition-all tw-duration-300 tw-ml-9 tw-leading-none" [class.tw-text-white]="showRaw" [class.tw-text-gray-700]="!showRaw">
				#
			</div>
		</div>
	</div>
	<div class="tw-col-span-6 tw-col-start-10 tw-row-start-1 tw-flex tw-items-center tw-justify-start  tw-font-bold sm:tw-text-lg tw-text-xs">
		<div class="text-uppercase px-3 tw-bg-[#243670] tw-border-2 tw-border-white tw-text-white print:tw-text-gray-200">Current</div>
	</div>

	<div class="tw-col-start-8 tw-row-start-1 tw-col-span-1 tw-flex tw-items-center tw-justify-start -tw-ml-7 tw-font-bold sm:tw-text-lg tw-text-xs border-2">
		<div class="text-uppercase px-3 tw-bg-[#243670] tw-border-2 tw-border-white tw-text-white print:tw-text-gray-200">Baseline</div>
</div>
</div>
</div>

	<!-- Participant data: Admin-only large slide-out drawer (trigger fixed at bottom) -->
	<ng-container *hasPermission="'Admin'">

		<button
			type="button"
			class="tw-fixed tw-bottom-6 tw-right-[170px] tw-z-[1000] tw-inline-flex tw-items-center tw-gap-2 tw-px-5 tw-py-3 tw-text-sm tw-font-semibold tw-text-gray-800 tw-bg-gray-100 tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-md tw-cursor-pointer tw-transition tw-duration-200 hover:tw-bg-gray-200 hover:tw-shadow-lg print:tw-hidden"
			*ngIf="data && participantTableData.length"
			(click)="toggleParticipantTable()"
			[attr.aria-expanded]="participantTableExpanded"
			aria-label="Open participant data drawer">
			<i class="fa fa-table" aria-hidden="true"></i>
			Participant data <span class="tw-text-xs tw-text-gray-500">({{participantTableData.length}} students)</span>
		</button>

		<div
			class="tw-fixed tw-inset-0 tw-z-[1100] tw-bg-transparent tw-pointer-events-none tw-transition-colors tw-duration-300 tw-ease-out"
			[class.tw-bg-\[rgba\(0\,0\,0\,0\.4\)\]]="participantTableExpanded"
			[class.tw-pointer-events-auto]="participantTableExpanded"
			(click)="participantTableExpanded && toggleParticipantTable()"
			role="presentation"
			aria-hidden="true"></div>

		<div
			class="tw-fixed tw-top-0 tw-right-0 tw-z-[1200] tw-w-[92vw] tw-max-w-[1200px] tw-h-screen tw-bg-white tw-shadow-2xl tw-flex tw-flex-col tw-transition-transform tw-duration-300 tw-ease-out"
			[ngClass]="participantTableExpanded ? 'tw-translate-x-0' : 'tw-translate-x-full'"
			role="dialog"
			aria-label="Participant data table"
			*ngIf="data && participantTableData.length">
			<header class="tw-flex tw-items-center tw-justify-between tw-shrink-0 tw-px-5 tw-py-4 tw-border-b tw-border-gray-200 tw-bg-gray-50">
				<h3 class="tw-m-0 tw-text-xl tw-font-bold tw-text-gray-900">Participant data</h3>
				<button
					type="button"
					class="tw-inline-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-p-0 tw-text-gray-500 tw-bg-transparent tw-border-0 tw-rounded-md tw-cursor-pointer tw-transition tw-duration-200 hover:tw-text-gray-900 hover:tw-bg-gray-200"
					(click)="toggleParticipantTable()"
					aria-label="Close drawer">
					<i class="fa fa-times" aria-hidden="true"></i>
				</button>
			</header>
			<div class="tw-flex-1 tw-min-h-0 tw-overflow-hidden tw-flex tw-flex-col tw-p-4 tw-gap-3">
				<!-- Search and column filters -->
				<div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-shrink-0">
					<input
						type="text"
						placeholder="Search name or classroom..."
						[(ngModel)]="participantTableSearch"
						class="tw-flex-1 tw-min-w-[160px] tw-max-w-[220px] tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-transparent" />
					<select
						[(ngModel)]="participantTableFilterClassroom"
						class="tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md tw-bg-white focus:tw-ring-2 focus:tw-ring-blue-500">
						<option value="">All classrooms</option>
						<option *ngFor="let c of participantTableClassrooms" [value]="c">{{ c }}</option>
					</select>
					<select
						[(ngModel)]="participantTableFilterBaselinePhase"
						class="tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md tw-bg-white focus:tw-ring-2 focus:tw-ring-blue-500">
						<option value="">Baseline: All phases</option>
						<option *ngFor="let p of participantTablePhaseOptions" [value]="p">{{ p }}</option>
					</select>
					<select
						[(ngModel)]="participantTableFilterBaselineDivision"
						class="tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md tw-bg-white focus:tw-ring-2 focus:tw-ring-blue-500">
						<option value="">Baseline: All divisions</option>
						<option *ngFor="let d of participantTableDivisionOptions" [value]="d">{{ d }}</option>
					</select>
					<select
						[(ngModel)]="participantTableFilterCurrentPhase"
						class="tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md tw-bg-white focus:tw-ring-2 focus:tw-ring-blue-500">
						<option value="">Current: All phases</option>
						<option *ngFor="let p of participantTablePhaseOptions" [value]="p">{{ p }}</option>
					</select>
					<select
						[(ngModel)]="participantTableFilterCurrentDivision"
						class="tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md tw-bg-white focus:tw-ring-2 focus:tw-ring-blue-500">
						<option value="">Current: All divisions</option>
						<option *ngFor="let d of participantTableDivisionOptions" [value]="d">{{ d }}</option>
					</select>
				</div>
				<div class="tw-flex-1 tw-min-h-0 tw-overflow-auto tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white">
					<table class="tw-w-full tw-text-sm tw-text-left tw-border-collapse">
						<thead class="tw-sticky tw-top-0 tw-z-10 tw-bg-gray-100 tw-border-b tw-border-gray-200">
							<tr>
								<th class="tw-p-2 tw-font-semibold tw-bg-gray-100">Name</th>
								<th class="tw-p-2 tw-font-semibold tw-bg-gray-100">Classroom</th>
								<th class="tw-p-2 tw-font-semibold tw-border-l tw-border-gray-300 tw-bg-gray-100">Assessed at baseline</th>
								<th class="tw-p-2 tw-font-semibold tw-border-l tw-border-gray-300 tw-bg-gray-100" colspan="3">Baseline</th>
								<th class="tw-p-2 tw-font-semibold tw-border-l tw-border-gray-300 tw-bg-gray-100" colspan="3">Current</th>
								<th class="tw-p-2 tw-font-semibold tw-border-l tw-border-gray-300 tw-bg-gray-100">Last test date</th>
								<th class="tw-p-2 tw-font-semibold tw-bg-gray-100">Times assessed</th>
							</tr>
							<tr class="tw-bg-gray-50">
								<th class="tw-p-2 tw-bg-gray-50"></th>
								<th class="tw-p-2 tw-bg-gray-50"></th>
								<th class="tw-p-2 tw-border-l tw-border-gray-300 tw-bg-gray-50"></th>
								<th class="tw-p-2 tw-border-l tw-border-gray-300 tw-bg-gray-50">Placement</th>
								<th class="tw-p-2 tw-bg-gray-50">Division</th>
								<th class="tw-p-2 tw-bg-gray-50">Not assessed</th>
								<th class="tw-p-2 tw-border-l tw-border-gray-300 tw-bg-gray-50">Placement</th>
								<th class="tw-p-2 tw-bg-gray-50">Division</th>
								<th class="tw-p-2 tw-bg-gray-50">Not assessed</th>
								<th class="tw-p-2 tw-border-l tw-border-gray-300 tw-bg-gray-50"></th>
								<th class="tw-p-2 tw-bg-gray-50"></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let row of filteredParticipantTableData" class="tw-border-b tw-border-gray-200 hover:tw-bg-gray-50 tw-transition-colors">
								<td class="tw-p-2">{{ row.name }}</td>
								<td class="tw-p-2">{{ row.classroom }}</td>
								<td class="tw-p-2 tw-border-l tw-border-gray-200">{{ row.assessedAtBaseline ? 'Yes' : 'No' }}</td>
								<td class="tw-p-2 tw-border-l tw-border-gray-200">{{ row.baselinePlacement }}</td>
								<td class="tw-p-2">{{ row.baselineDivision }}</td>
								<td class="tw-p-2">{{ row.baselineNotAssessed ? 'Yes' : 'No' }}</td>
								<td class="tw-p-2 tw-border-l tw-border-gray-200">{{ row.currentPlacement }}</td>
								<td class="tw-p-2">{{ row.currentDivision }}</td>
								<td class="tw-p-2">{{ row.currentNotAssessed ? 'Yes' : 'No' }}</td>
								<td class="tw-p-2 tw-border-l tw-border-gray-200">{{ row.lastTestDate }}</td>
								<td class="tw-p-2">{{ row.timesAssessed }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</ng-container>
<!-- <div  class="tw-grid  tw-col-span-7  .sm:tw-grid-cols-12 tw-grid-cols-12 lg:tw-pl-20 md:tw-pl-10 tw-grid-rows-1 tw-gap-0 sm:tw-text-xl tw-text-lg tw-my-2 tw-w-full"><div  class="tw-col-span-8 tw-row-start-1 tw-flex tw-items-center tw-justify-end tw-font-bold sm:tw-text-lg tw-text-xs"><div  class="text-uppercase px-3 tw-bg-[#243670] tw-border-2 tw-border-white tw-text-white print:tw-text-gray-200">Baseline</div></div><div _ngcontent-cyi-c135="" class="tw-col-start-9 tw-row-start-1 tw-col-span-1 tw-flex tw-items-center tw-justify-end tw-font-bold sm:tw-text-lg tw-text-xs border-2"></div><div _ngcontent-cyi-c135="" class="tw-col-start-10 tw-row-start-1 tw-col-span-1 tw-flex tw-items-center tw-justify-end tw-font-bold sm:tw-text-lg tw-text-xs border-2 tw-pl-2"><div _ngcontent-cyi-c135="" class="text-uppercase px-3 tw-bg-[#243670] tw-border-2 tw-border-white tw-text-white print:tw-text-gray-200">Current</div></div></div> -->

<!-- <div class="tw-col-start-8  tw-grid tw-grid-cols-8 tw-grid-rows-5 tw-justify-end tw-gap-2">
  <div class="tw-row-start-5 tw-col-span-2 tw-bg-blue-500 tw-p-4 tw-text-white">
    11
  </div>
  <div class="tw-row-start-4 tw-col-span-3 tw-bg-blue-500 tw-p-4 tw-text-white tw-bg-blue-100 tw-pl-2">
    22
  </div>
  <div class="tw-row-start-3 tw-col-span-4 tw-bg-blue-500 tw-p-4 tw-text-white">
    33
  </div>
  <div class="tw-row-start-2 tw-col-span-5 tw-bg-blue-500 tw-p-4 tw-text-white">
    44
  </div>
  <div class="tw-row-start-1 tw-col-span-6 tw-bg-blue-500 tw-p-4 tw-text-white">
    55
  </div>
  <div class="tw-col-start-7 tw-bg-blue-500 tw-p-4 tw-text-white">1</div>
  <div class="tw-col-start-6 tw-bg-blue-500 tw-p-4 tw-text-white">2</div>
  <div class="tw-col-start-5 tw-bg-blue-500 tw-p-4 tw-text-white">3</div>
  <div class="tw-col-start-4 tw-bg-blue-500 tw-p-4 tw-text-white">4</div>
  <div class="tw-col-start-3 tw-bg-blue-500 tw-p-4 tw-text-white tw-bg-blue-50">5</div>
</div> -->

